"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumConvertors = void 0;
const window_state_1 = require("../enums/window_state");
/** @internal */
class EnumConvertors {
    static ToWindowState(owWindowState) {
        switch (owWindowState) {
            case "minimized" /* minimized */: {
                return window_state_1.WindowState.Minimized;
            }
            case "maximized" /* maximized */: {
                return window_state_1.WindowState.Maximize;
            }
            case "hidden" /* hidden */: {
                return window_state_1.WindowState.Hidden;
            }
            case "normal" /* normal */: {
                return window_state_1.WindowState.Normal;
            }
            case "closed" /* closed */: {
                return window_state_1.WindowState.Closed;
            }
            default:
                throw new Error(`unknown window state ${owWindowState}`);
        }
    }
}
exports.EnumConvertors = EnumConvertors;
//# sourceMappingURL=enums_convertors.js.map